module.exports = "<input #input (keydown)=\"onKeyDown($event)\" [(ngModel)]=\"value\" style=\"width: 100%\">\r\n"